"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unmarshall = exports.marshall = void 0;
function marshall(_) {
    return '';
}
exports.marshall = marshall;
function unmarshall(_) {
    return '';
}
exports.unmarshall = unmarshall;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidW5rbm93bi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wbHVnaW5zL3Vua25vd24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsU0FBZ0IsUUFBUSxDQUFDLENBQVM7SUFDOUIsT0FBTyxFQUFFLENBQUM7QUFDZCxDQUFDO0FBRkQsNEJBRUM7QUFDRCxTQUFnQixVQUFVLENBQUMsQ0FBUztJQUNoQyxPQUFPLEVBQUUsQ0FBQztBQUNkLENBQUM7QUFGRCxnQ0FFQyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBmdW5jdGlvbiBtYXJzaGFsbChfOiBzdHJpbmcpIHtcbiAgICByZXR1cm4gJyc7XG59XG5leHBvcnQgZnVuY3Rpb24gdW5tYXJzaGFsbChfOiBzdHJpbmcpIHtcbiAgICByZXR1cm4gJyc7XG59XG4iXX0=